import type { Ref } from '@wix/materializer'
import type { Component, InternalRefDataItem, WidgetRefDataItem } from '@wix/thunderbolt-becky-types'
import { removeHash } from '@wix/thunderbolt-catharsis'
import { getRefTemplateKey, isRefComponent } from '../../byRefUtils'
import { createByRefsisCompNode, ScopedCreateRef } from '../../compNodeUtils'

export const RefComponentsTemplateData = createByRefsisCompNode<
	Ref<WidgetRefDataItem | InternalRefDataItem> | undefined,
	{ templateKey: string; rootCompId: string; sharedPart: boolean } | null
>({
	getDependencies: (component: Component, scopedCreateRef?: ScopedCreateRef) =>
		isRefComponent(component)
			? (scopedCreateRef!('document_data', removeHash(component.dataQuery!)) as Ref<WidgetRefDataItem>)
			: undefined,
	toViewItem: (__, refCompData) => {
		if (!refCompData) {
			return null
		}

		return {
			templateKey: getRefTemplateKey(refCompData),
			rootCompId: (refCompData as InternalRefDataItem).rootCompId,
			sharedPart:
				refCompData.type === 'InternalRef' && (!refCompData.pageId || refCompData.pageId === 'masterPage'),
		}
	},
})
